export const dataSeller = [
  {
    img: "https://www.jiomart.com/images/product/150x150/490008739/parle-g-original-glucose-biscuits-800-g-0-20210115.jpg",
    name: "Parle-G Biscuits 800 g ",
    price: "67.50",
    mrp: "M.R.P: 75.00",
    save: "You Save: 7.50",
  },
  {
    img: "https://www.jiomart.com/images/product/150x150/490003834/maggi-2-minute-masala-instant-noodles-560-g-0-20210811.jpg",
    name: "Maggi Noodles 560g ",
    price: "79.00",
    mrp: "M.R.P: 96.00",
    save: "You Save: 17.00",
  },
  {
    img: "https://www.jiomart.com/images/product/150x150/590108360/sugar-m-2-kg-0-20210316.jpg",
    name: "Sugar clear (M) 2 kg",
    price: " 81.00",
    mrp: "M.R.P:  95.00",
    save: "You Save:  14.00",
  },
  {
    img: "https://www.jiomart.com/images/product/150x150/491349660/chakki-atta-10-kg-0-20210301.jpg",
    name: "Chakki  gold Atta 10 kg",
    price: "285.00",
    mrp: "M.R.P: 375.00",
    save: "You Save: 90.00",
  },
  {
    img: "https://www.jiomart.com/images/product/420x420/490915877/lux-rose-vitamin-e-soft-glowing-skin-soap-bar-150-g-pack-of-3-0-20210818.jpg",
    name: "Lux Rose 150g (Pack of 3)",
    price: "96.00",
    mrp: " M.R.P: 149.00",
    save: "You Save:  53.00",
  },
  {
    img: "https://www.jiomart.com/images/product/420x420/491215527/whisper-ultra-wings-sanitary-napkin-with-wings-xl-44-pads-0-20210112.jpg",
    name: "Whisper Ultra  (XL+) 44 pads",
    price: " 339.00",
    mrp: " M.R.P: 449.00",
    save: "You Save: 110.00",
  },
  {
    img: "https://www.jiomart.com/images/product/150x150/490672482/dabur-red-toothpaste-200-100-g-with-free-toothbrush-0-20210514.jpg",
    name: "Dabur Red Toothpaste 300 g ",
    price: "103.34",
    mrp: "M.R.P:  155.00",
    save: "You Save:  51.66",
  },
  {
    img: "https://www.jiomart.com/images/product/420x420/491441280/surf-excel-matic-top-load-detergent-powder-4-kg-get-extra-2-kg-free-0-20210125.jpg",
    name: "Surf Excel  4 kg ( Extra 2 kg Free)",
    price: " 869.00",
    mrp: "M.R.P: 1100.00",
    save: "You Save:  231.00",
  },
  {
    img: "https://www.jiomart.com/images/product/150x150/491215021/gala-no-dust-broom-xl-0-20210825.jpg",
    name: "Gala No Dust Broom (XL)",
    price: " 159.00",
    mrp: " M.R.P: 200.00",
    save: "You Save: 41.00",
  },
  {
    img: "https://www.jiomart.com/images/product/150x150/490010199/amul-cheese-block-1-kg-carton-0-20210324.jpg",
    name: "Amul Cheese Block 1 kg (Carton)",
    price: " 437.00",
    mrp: " M.R.P: 470.00",
    save: "You Save: 33.00",
  },
];

export const posterimg = [
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1632332387_Kelloggs-Range_Jio_Mart_600x350.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1632404550_colwm.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1632404398_fwm.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1629988766_webmini.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1623423184_wm.jpg",
  },
  {
    img: "https://www.jiomart.com/images/cms/aw_rbslider/slides/1607437940_buybig_webmini.jpg",
  },
];

export const mensdata = [
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/516.png?v=1628786706",
  },
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/562.png?v=1628786706",
  },
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/515.png?v=1628786706",
  },
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/505.png?v=1628786706",
  },
  {
    img: "https://www.jiomart.com/images/cms/section/category/503/592.png?v=1628786706",
  },
];

export const BigMenData = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/503/509.png?v=1628786706",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/503/508.png?v=1628786706",
  },
];

export const KidsFashion = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/507.png?v=1628783932",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/565.png?v=1628783932",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/506.png?v=1628783932",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/549.png?v=1628783932",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/502/571.png?v=1628783932",
  },
];

export const HottestDeals = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/509.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/579.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/507.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/515.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/527.png?v=1628791106",
  },

  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/516.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/530.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/508.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/584.png?v=1628791106",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/501/525.png?v=1628791106",
  },
];

export const groceries = [
  {
    image:
      "https://www.jiomart.com/images/category/188/thumb/breakfast-cereals-20200603.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/117/thumb/dairy-20200522.png",
  },
  {
    image: "https://www.jiomart.com/images/category/17/thumb/0-17.png",
  },
  {
    image: "https://www.jiomart.com/images/category/20/thumb/0-20.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/119/thumb/bath-hand-wash-20200714.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/7/thumb/toothpaste-20200520.png",
  },
  {
    image: "https://www.jiomart.com/images/category/26/thumb/0-26.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/213/thumb/paper-tissues-napkins-20210727.png",
  },
];

export const GrocerieSlider = [
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/592200116/saffola-gold-refined-rice-bran-and-sunflower-based-blended-oil-3-l-daawat-devaaya-basmati-rice-5-kg-combo-pack-0-20220624.jpg",
    heading:
      "Saffola Gold Refined Rice Bran And Sunflower Based Blended Oil 3 L + Daawat Devaaya Basmati Rice 5 kg (Combo Pack) ",
    price: "₹ 875.00",
    mrp: "M.R.P:",
    rupees: "₹ 1313",
    save: "₹ 435.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/600x600/491055460/colgate-strong-teeth-dental-cream-toothpaste-500-g-saver-pack-product-images-o491055460-p491055460-0-202203151056.jpg",
    heading: "Colgate Strong Teeth Dental Cream Toothpaste 500 g Saver Pack",
    price: "₹ 188.00",
    mrp: "M.R.P:",
    rupees: "₹ 253",
    save: "₹ 65.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492367966/surf-excel-easy-wash-detergent-powder-5-kg-product-images-o492367966-p590837659-0-202208111657.jpg",
    heading: "Surf Excel Easy Wash Detergent Powder 5 kg",
    price: "₹ 678.00",
    mrp: "M.R.P:",
    rupees: "₹ 730",
    save: "₹ 52.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490003834/maggi-2-minute-masala-instant-noodles-560-g-product-images-o490003834-p490003834-0-202203150702.jpg",
    heading: "Maggi 2-Minute Masala Instant Noodles 560 g",
    price: "₹ 92.00",
    mrp: "M.R.P:",
    rupees: "₹ 102",
    save: "₹ 17.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490001392/amul-butter-500-g-carton-product-images-o490001392-p490001392-0-202203152128.jpg",
    heading: "Amul Butter 500 g (Cartoon)",
    price: "₹ 245.00",
    mrp: "M.R.P:",
    rupees: "₹ 255",
    save: "₹ 10.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490001392/amul-butter-500-g-carton-product-images-o490001392-p490001392-0-202203152128.jpg",
    heading: "Tul / Arhar Dal 2 Kg",
    price: "₹ 252.00",
    mrp: "M.R.P:",
    rupees: "₹ 300",
    save: "₹ 48.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490008332/closeup-everfresh-red-hot-gel-toothpaste-150-g-pack-of-2-product-images-o490008332-p490008332-0-202206222347.jpg",
    heading: "Closeup Everfresh+ Red Hot Gel Toothpaste 150 g (Pack of 2)",
    price: "₹ 163.00",
    mrp: "M.R.P:",
    rupees: "₹ 182",
    save: "₹ 19.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492848164/surf-excel-matic-front-load-detergent-powder-6-kg-product-images-o492848164-p591223797-0-202204291101.jpg",
    heading: "Surf Excel Matic Front Load Detergent Powder 6 kg",
    price: "₹ 1325.00",
    mrp: "M.R.P:",
    rupees: "₹ 1425",
    save: "₹ 100.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492391349/kissan-fresh-tomato-ketchup-1-2-kg-product-images-o492391349-p590809928-0-202203150627.jpg",
    heading: "Kissan Fresh Tomato Ketchup 1.2 Kg",
    price: "₹ 125.00",
    mrp: "M.R.P:",
    rupees: "₹ 160",
    save: "₹ 35.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/490010244/gowardhan-pure-cow-ghee-1-l-pouch-product-images-o490010244-p490010244-0-202203150918.jpg",
    heading: "Govardhan Pure Ghee 1Litre (Pouch)",
    price: "₹ 566.00",
    mrp: "M.R.P:",
    rupees: "₹ 609",
    save: "₹ 43.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/491252835/tide-jasmine-rose-detergent-powder-5-kg-get-extra-1-kg-free-product-images-o491252835-p590838653-0-202203151949.jpg",
    heading: "Tide Jasmine & Rose Detergent Powder 5 Kg",
    price: "₹ 637.00",
    mrp: "M.R.P:",
    rupees: "₹ 635",
    save: "₹ 48.00",
  },
  {
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/491319789/sunfeast-dark-fantasy-original-choco-filled-biscuits-300-g-product-images-o491319789-p491319789-0-202205301919.jpg",
    heading: "Sunfeast Dark Fantasy Original Choco Filled",
    price: "₹ 99.00",
    mrp: "M.R.P:",
    rupees: "₹ 170",
    save: "₹ 71.00",
  },
];

//
export const SmartPhonesSlider = [
  {
    dis_section: "off",
    "dis_section 2": 30,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/realme-narzo-50a-128-gb-4-gb-ram-oxygen-blue-mobile-phone/594779615",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/493178791/realme-narzo-50a-128-gb-4-gb-ram-oxygen-blue-mobile-phone-digital-o493178791-p594779615-0-202210221327.jpeg",
    heading: "Realme Narzo 50A 128 GB, 4 GB RAM,..",
    price: "₹ 10,499.00",
    mrp: "M.R.P:",
    rupees: "₹ 14,999.00",
    save: "Save ₹ 4,500.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 16,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/apple-iphone-12-128-gb-black/590441373",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/491901533/apple-iphone-12-128-gb-black-digital-o491901533-p590441373-0-202207250045.jpeg",
    heading: "Apple iPhone 12 128 GB, Black",
    price: "₹ 53,900.00",
    mrp: "M.R.P:",
    rupees: "₹ 64,900.00",
    save: "Save ₹ 11,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 29,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/redmi-10-128-gb-6-gb-ram-midnight-black-mobile-phone/591469929",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492849854/redmi-10-128-gb-6-gb-ram-midnight-black-mobile-phone-digital-o492849854-p591469929-0-202205192214.jpeg",
    heading: "Redmi 10 128 GB, 6 GB RAM, Midnight..",
    price: "₹ 11,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 16,999.00",
    save: "Save ₹ 5,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 30,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/moto-g31-64-gb-4-gb-ram-baby-blue-smartphone/591163176",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492849083/motorola-g31-64-gb-4-gb-ram-baby-blue-mobile-phone-digital-o492849083-p591163176-0-202204132005.jpeg",
    heading: "Motorola G31 64 GB, 4 GB RAM, Baby..",
    price: "₹ 10,499.00",
    mrp: "M.R.P:",
    rupees: "₹ 14,999.00",
    save: "Save ₹ 4,500.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 27,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/motorola-g62-5g-128-gb-6-gb-ram-midnight-grey-mobile-phone/593409619",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/493177198/motorola-g62-5g-128-gb-6-gb-ram-midnight-grey-mobile-phone-digital-o493177198-p593409619-0-202208102107.jpeg",
    heading: "Motorola G62 5G 128 GB, 6 GB RAM, M..",
    price: "₹ 15,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 21,999.00",
    save: "Save ₹ 6,000.00",
  },

  {
    dis_section: "off",
    "dis_section 2": 31,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/motorola-g51-5g-64-gb-4-gb-ram-indigo-blue-smartphone/591193919",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492849093/motorola-g51-5g-64-gb-4-gb-ram-indigo-blue-smartphone-digital-o492849093-p591193919-0-202203101232.jpeg",
    heading: "Motorola G51 5G 64 GB, 4 GB RAM, In..",
    price: "₹ 12,249.00",
    mrp: "M.R.P:",
    rupees: "₹ 17,999.00",
    save: "Save ₹ 5,750.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 23,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/xiaomi-redmi-9-activ-128-gb-6-gb-ram-metallic-purple-smartphone/590837915",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/491998280/xiaomi-redmi-9-activ-128-gb-6-gb-ram-metallic-purple-smartphone-digital-o491998280-p590837915-0-202110292148.jpeg",
    heading: "Xiaomi Redmi 9 Activ 128 GB, 6 GB R..",
    price: "₹ 9,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 12,999.00",
    save: "Save ₹ 3,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 30,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/tecno-spark-9-64gb-4gb-ram-infinity-black-mobile-phone/592917643",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/493177160/tecno-spark-9-64gb-4gb-ram-infinity-black-mobile-phone-digital-o493177160-p592917643-0-202207222123.jpeg",
    heading: "Tecno Spark 9 64GB, 4GB RAM, Infini..",
    price: "₹ 7,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 11,499.00",
    save: "Save ₹ 3,500.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 23,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/redmi-note-11-se-64-gb-6-gb-ram-bifrost-blue-mobile-phone/594779644",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/493178810/redmi-note-11-se-64-gb-6-gb-ram-bifrost-blue-mobile-phone-digital-o493178810-p594779644-0-202210221329.jpeg",
    heading: "Redmi Note 11 SE 64 GB, 6 GB RAM, B..",
    price: "₹ 12,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 16,999.00",
    save: "Save ₹ 4,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 16,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/moto-g22-64-gb-4-gb-ram-iceberg-blue-mobile-phone/591220523",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492849923/moto-g22-64-gb-4-gb-ram-iceberg-blue-mobile-phone-digital-o492849923-p591220523-0-202204261414.jpeg",
    heading: "Moto g22 64 GB, 4 GB RAM, Iceberg B..",
    price: "₹ 9,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 11,999.00",
    save: "Save ₹ 2,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 25,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/realme-c33-32-gb-3-gb-ram-night-sea-mobile-phone/594311454",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/493177735/realme-c33-32-gb-3-gb-ram-night-sea-mobile-phone-digital-o493177735-p594311454-0-202210070509.jpeg",
    heading: "Realme C33 32 GB, 3 GB RAM, Night S..",
    price: "₹ 8,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 11,999.00",
    save: "Save ₹ 3,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 7,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/apple-iphone-13-128-gb-midnight-black/590798548",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/491997699/apple-iphone-13-128-gb-midnight-black-digital-o491997699-p590798548-0-202208221207.jpeg",
    heading: "Apple iPhone 13 128 GB, Midnight (B..",
    price: "₹ 64,900.00",
    mrp: "M.R.P:",
    rupees: "₹ 69,900.00",
    save: "Save ₹ 5,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 31,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/tecno-spark-9-128gb-6gb-ram-sky-mirror-mobile-phone/592917646",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/493177163/tecno-spark-9-128gb-6gb-ram-sky-mirror-mobile-phone-digital-o493177163-p592917646-0-202207222123.jpeg",
    heading: "Tecno Spark 9 128GB, 6GB RAM, Sky M..",
    price: "₹ 9,249.00",
    mrp: "M.R.P:",
    rupees: "₹ 13,499.00",
    save: "Save ₹ 4,250.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 18,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/apple-iphone-12-64-gb-black/590441378",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/491901528/apple-iphone-12-64-gb-black-digital-o491901528-p590441378-0-202112162016.jpeg",
    heading: "Apple iPhone 12 64 GB, Black",
    price: "₹ 48,900.00",
    mrp: "M.R.P:",
    rupees: "₹ 59,900.00",
    save: "Save ₹ 11,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 33,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/redmi-10-64-gb-4-gb-ram-caribbean-green-mobile-phone/591469937",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492849853/redmi-10-64-gb-4-gb-ram-caribbean-green-mobile-phone-digital-o492849853-p591469937-0-202205192214.jpeg",
    heading: "Redmi 10 64 GB, 4 GB RAM, Caribbean..",
    price: "₹ 9,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 14,999.00",
    save: "Save ₹ 5,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 21,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/vivo-y16-64-gb-4-gb-ram-drizzling-gold-mobile-phone/594348586",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/493178408/vivo-y16-64-gb-4-gb-ram-drizzling-gold-mobile-phone-digital-o493178408-p594348586-0-202210081530.jpeg",
    heading: "Vivo Y16 64 GB, 4 GB RAM, Drizzlin..",
    price: "₹ 12,499.00",
    mrp: "M.R.P:",
    rupees: "₹ 15,999.00",
    save: "Save ₹ 3,500.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 26,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/motorola-g71-128-gb-6-gb-ram-iris-blue-mobile-phone/591278373",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492849088/motorola-g71-128-gb-6-gb-ram-iris-blue-mobile-phone-digital-o492849088-p591278373-0-202205120857.jpeg",
    heading: "Motorola G71, 128 GB, 6 GB RAM, Iri..",
    price: "₹ 16,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 22,999.00",
    save: "Save ₹ 6,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 39,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/motorola-e32s-32-gb-3-gb-ram-misty-silver-mobile-phone/591570044",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492849905/motorola-e32s-32-gb-3-gb-ram-misty-silver-mobile-phone-digital-o492849905-p591570044-0-202205242324.jpeg",
    heading: "Motorola E32s 32 GB, 3 GB RAM, Mist..",
    price: "₹ 7,499.00",
    mrp: "M.R.P:",
    rupees: "₹ 12,299.00",
    save: "Save ₹ 4,800.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 29,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/motorola-moto-g42-64gb-4gb-ram-atlantic-green-mobile-phone/592617134",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492850894/motorola-moto-g42-64gb-4gb-ram-atlantic-green-mobile-phone-digital-o492850894-p592617134-0-202207151324.jpeg",
    heading: "Motorola Moto G42 64GB, 4GB RAM, At..",
    price: "₹ 11,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 16,999.00",
    save: "Save ₹ 5,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 29,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/redmi-10-128-gb-6-gb-ram-pacific-blue-mobile-phone/591469930",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492849855/redmi-10-128-gb-6-gb-ram-pacific-blue-mobile-phone-digital-o492849855-p591469930-0-202205192214.jpeg",
    heading: "Redmi 10 128 GB, 6 GB RAM, Pacific..",
    price: "₹ 11,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 16,999.00",
    save: "Save ₹ 5,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 17,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/samsung-m13-5g-128-gb-6-gb-ram-aqua-green-mobile-phone/594137347",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/493178367/samsung-m13-5g-128-gb-6-gb-ram-aqua-green-mobile-phone-digital-o493178367-p594137347-0-202209281630.jpeg",
    heading: "Samsung M13 5G 128 GB, 6 GB RAM, Aq..",
    price: "₹ 15,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 19,499.00",
    save: "Save ₹ 3,500.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 34,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/vivo-y15c-32-gb-3-gb-ram-mystic-blue-mobile-phone/591474016",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/492850289/vivo-y15c-32-gb-3-gb-ram-mystic-blue-mobile-phone-digital-o492850289-p591474016-0-202208122017.jpeg",
    heading: "VIVO Y15c 32 GB, 3 GB RAM, Mystic B..",
    price: "₹ 9,499.00",
    mrp: "M.R.P:",
    rupees: "₹ 14,490.00",
    save: "Save ₹ 4,991.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 10,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/oneplus-10t-5g-128-gb-8-gb-ram-moonstone-black-mobile-phone/593407064",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/493177297/oneplus-10t-5g-128-gb-8-gb-ram-moonstone-black-mobile-phone-digital-o493177297-p593407064-0-202208042343.jpeg",
    heading: "OnePlus 10T 5G 128 GB, 8 GB RAM, Mo..",
    price: "₹ 44,999.00",
    mrp: "M.R.P:",
    rupees: "₹ 49,999.00",
    save: "Save ₹ 5,000.00",
  },
  {
    dis_section: "off",
    "dis_section 2": 17,
    per_txt: "%",
    "pro_detail href":
      "https://www.jiomart.com/p/electronics/redmi-9a-sport-32-gb-3-gb-ram-carbon-black-smartphone/590837948",
    imgSrc:
      "https://www.jiomart.com/images/product/150x150/491998272/redmi-9a-sport-32-gb-3-gb-ram-carbon-black-smartphone-digital-o491998272-p590837948-0-202110292155.jpeg",
    heading: "Redmi 9A Sport 32 GB 3 GB RAM, Carb..",
    price: "₹ 7,799.00",
    mrp: "M.R.P:",
    rupees: "₹ 9,499.00",
    save: "Save ₹ 1,700.00",
  },
];

export const mobileTopBrands = [
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1667198627_05_Mobile.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1667198627_05_Mobile.jpg",
  },
];

export const shopCategory = [
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109073_1654018509_Fruits-Veg.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109088_1654018530_Beverage-Corner.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109143_1656693044_Foodgrains-Oils.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109179_1654018570_Snacks-FOOD.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109205_1654018587_Home-care.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109260_1654018604_personal-Care.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109280_1654018629_Dairy-Bakery.jpg",
  },

  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109301_1654018647_Instant-Foods.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109301_1654018647_Instant-Foods.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109327_1654018658_Home-Kitchen.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109344_1654018675_Mens-Wear.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109379_1654018684_Womens-Wear.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1657109408_1654018699_Kids-WEAR.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661329065_02--Shop-From-Top-Categories-Kitchen-Appliances.jpg",
  },
];

export const lengthdata = [
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1659964260_Cred-pay-Package_910x278.jpg",
  },

  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660291721_Twid-Banners-August_910x278.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660291926_jiomart-svg_910x278_1.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1659290092_Paytm-910-X-278.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660291926_jiomart-svg_910x278_1.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1659964260_Cred-pay-Package_910x278.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661239396_910-278-freecharge.jpg",
  },
];

export const categorydata = [
  {
    image:
      "https://www.jiomart.com/images/category/6/thumb/0-6.png?v=1607022291",
    title: "Personal Care",
  },
  {
    image:
      "https://www.jiomart.com/images/category/7/thumb/0-7.png?v=1607022291",
    title: "Home Care",
  },
  {
    image:
      "https://www.jiomart.com/images/category/10/thumb/0-10.png?v=1607022291",
    title: "Baby Care",
  },
  {
    image:
      "https://www.jiomart.com/images/category/13/thumb/staples-20200710.jpg?v=1607022291",
    title: "Staples",
  },
  {
    image:
      "https://www.jiomart.com/images/category/11/thumb/0-11.png?v=1607022291",
    title: "Snacks and Branded Foods",
  },
  {
    image:
      "https://www.jiomart.com/images/category/12/thumb/0-12.png?v=1607022291",
    title: "Dairy & Bakery",
  },
  {
    image:
      "https://www.jiomart.com/images/category/141/thumb/fruits-vegetables-20200520.png?v=1607022291",
    title: "Fruits & Vegetables",
  },
  {
    image:
      "https://www.jiomart.com/images/category/3/thumb/0-3.png?v=1607022291",
    title: "Beverages",
  },
];

export const BigWomenData = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/527.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/579.png?v=1651706581",
  },
];

export const SmallWomenData = [
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/511.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/525.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/530.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/572.png?v=1651706581",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/section/category/498/578.png?v=1651706581",
  },
];

export const Personal = [
  {
    image:
      "https://www.jiomart.com/images/category/37/thumb/all-purpose-cleaners-20200603.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/43/thumb/detergent-bars-20200520.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/17/thumb/feminine-hygiene-20200605.png",
  },
  {
    image: "https://www.jiomart.com/images/category/28/thumb/0-28.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/6/thumb/oral-care-20200603.png",
  },
  {
    image: "https://www.jiomart.com/images/category/31/thumb/0-31.png",
  },
  {
    image: "https://www.jiomart.com/images/category/10/thumb/0-10.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/213/thumb/paper-tissues-napkins-20210727.png",
  },
];

export const HomeData = [
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661510233_Cheese-creative-Digital-Banner_2.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1645558047_web_mini.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1624538640_wm.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1628171483_Chinese_webmini.jpg",
  },
];

export const Offer = [
  {
    image:
      "https://www.jiomart.com/images/category/188/thumb/breakfast-cereals-20200603.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/117/thumb/dairy-20200522.png",
  },
  {
    image: "https://www.jiomart.com/images/category/17/thumb/0-17.png",
  },
  {
    image: "https://www.jiomart.com/images/category/15/thumb/0-15.png",
  },
  {
    image: "https://www.jiomart.com/images/category/135/thumb/0-135.png",
  },
  {
    image: "https://www.jiomart.com/images/category/25/thumb/0-25.png",
  },
  {
    image: "https://www.jiomart.com/images/category/26/thumb/0-26.png",
  },
  {
    image:
      "https://www.jiomart.com/images/category/221/thumb/papads-ready-to-fry-20200520.png",
  },
];

export const downData = [
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661278487_Powered-TB-Banner-4---600X350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1626259904_wm.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1654538046_600x350-Hot-Spot.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660816405_01--Apples-Banner_600x350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661279354_Apple_Cider_Vinegar-600x350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661538125_600x350_kEVENTER.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661538198_600X350_SENSODYNE.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1660036332_Mobilebanner_StaplesWeek_2_600x350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1626448037_snackswebmini.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1659004297_600x350-Buy-at-99.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1641903326_Your-Favourite-Noodle_600x350.jpg",
  },
  {
    image:
      "https://www.jiomart.com/images/cms/aw_rbslider/slides/1661278487_Powered-TB-Banner-4---600X350.jpg",
  },
];

export const kitchenData = [
  [
    {
      "dis_section 2": 17,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/sugar-m-2-kg/590108360",
      imgSrc:
        "https://www.jiomart.com/images/product/150x150/491696003/sugar-m-2-kg-product-images-o491696003-p590108360-0-202205272027.jpg",
      heading: "Sugar (M) 2 kg",
      price: "₹ 83.00",
      mrp: "M.R.p:",
      rupees: "₹ 100.00",
      save: "Save ₹ 17.00",
    },
    {
      "dis_section 2": 14,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/chakki-atta-10-kg/491349660",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/491349660/chakki-atta-10-kg-product-images-o491349660-p491349660-0-202206231932.jpg",
      heading: "Chakki Atta 10 kg",
      price: "₹ 339.00",
      mrp: "M.R.p:",
      rupees: "₹ 395.00",
      save: "Save ₹ 56.00",
    },
    {
      "dis_section 2": 21,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/good-life-sugar-m-5-kg/491551495",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/491551495/good-life-pure-crystal-sugar-m-5-kg-product-images-o491551495-p491551495-0-202205272019.jpg",
      heading: "Good Life Pure Crystal Sugar (M) 5 kg",
      price: "₹ 215.00",
      mrp: "M.R.p:",
      rupees: "₹ 275.00",
      save: "Save ₹ 60.00",
    },
    {
      "dis_section 2": 18,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/tur-arhar-dal-2-kg/491417390",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/491417390/tur-arhar-dal-2-kg-product-images-o491417390-p491417390-0-202203170610.jpg",
      heading: "Tur / Arhar Dal 2 kg",
      price: "₹ 246.00",
      mrp: "M.R.p:",
      rupees: "₹ 300.00",
      save: "Save ₹ 54.00",
    },
    {
      "dis_section 2": 14,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/aashirvaad-superior-mp-whole-wheat-atta-10-kg/590150649",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/490750662/aashirvaad-superior-mp-whole-wheat-atta-10-kg-product-images-o490750662-p590150649-0-202203171046.jpg",
      heading: "Aashirvaad Superior MP Whole Wheat Atta 10 kg",
      price: "₹ 459.00",
      mrp: "M.R.p:",
      rupees: "₹ 534.00",
      save: "Save ₹ 75.00",
    },
    {
      "dis_section 2": 38,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/good-life-almonds-500-g/491186625",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/491186625/good-life-almonds-500-g-product-images-o491186625-p491186625-0-202205180139.jpg",
      heading: "Good Life Almonds 500 g",
      price: "₹ 339.00",
      mrp: "M.R.p:",
      rupees: "₹ 549.00",
      save: "Save ₹ 210.00",
    },
    {
      "dis_section 2": 27,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/saffola-gold-rice-bran-based-blended-oil-3-l/590860238",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/492571049/saffola-gold-rice-bran-based-blended-oil-3-l-product-images-o492571049-p590860238-0-202203170449.jpg",
      heading: "Saffola Gold Rice Bran Based Blended Oil 3 L",
      price: "₹ 499.00",
      mrp: "M.R.p:",
      rupees: "₹ 690.00",
      save: "Save ₹ 191.00",
    },
    {
      "dis_section 2": 20,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/gemini-refined-sunflower-oil-1-l-pouch/490012719",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/490012719/gemini-refined-sunflower-oil-1-l-product-images-o490012719-p490012719-0-202203151822.jpg",
      heading: "Gemini Refined Sunflower Oil 1 L",
      price: "₹ 184.00",
      mrp: "M.R.p:",
      rupees: "₹ 230.00",
      save: "Save ₹ 46.00",
    },
    {
      "dis_section 2": 17,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/fortune-sun-lite-refined-sunflower-oil-5-l-jar/490005647",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/490005647/fortune-sunlite-refined-sunflower-oil-5-l-product-images-o490005647-p490005647-0-202205180140.jpg",
      heading: "Fortune Sunlite Refined Sunflower Oil 5 L",
      price: "₹ 945.00",
      mrp: "M.R.p:",
      rupees: "₹ 1145.00",
      save: "Save ₹ 200.00",
    },
    {
      "dis_section 2": 25,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/moong-dal-2-kg/491432711",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/491432711/moong-dal-2-kg-product-images-o491432711-p491432711-0-202205191636.jpg",
      heading: "Moong Dal 2 kg",
      price: "₹ 200.00",
      mrp: "M.R.p:",
      rupees: "₹ 270.00",
      save: "Save ₹ 70.00",
    },
    {
      "dis_section 2": 18,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/surti-kolam-rice-10-kg/491349730",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/491349730/surti-kolam-rice-10-kg-product-images-o491349730-p491349730-0-202205172238.jpg",
      heading: "Surti Kolam Rice 10 kg",
      price: "₹ 639.00",
      mrp: "M.R.p:",
      rupees: "₹ 780.00",
      save: "Save ₹ 141.00",
    },
    {
      "dis_section 2": 10,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/tata-iodised-salt-1-kg/490000073",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/490000073/tata-iodised-salt-1-kg-product-images-o490000073-p490000073-0-202206021938.jpg",
      heading: "Tata Iodised Salt 1 kg",
      price: "₹ 25.00",
      mrp: "M.R.p:",
      rupees: "₹ 28.00",
      save: "Save ₹ 3.00",
    },
    {
      "dis_section 2": 30,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/chana-dal-2-kg/491417393",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/491417393/chana-dal-2-kg-product-images-o491417393-p491417393-0-202203170754.jpg",
      heading: "Chana Dal 2 kg",
      price: "₹ 140.00",
      mrp: "M.R.p:",
      rupees: "₹ 200.00",
      save: "Save ₹ 60.00",
    },
    {
      "dis_section 2": 20,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/hmt-kolam-rice-10-kg/491349728",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/491349728/hmt-kolam-rice-10-kg-product-images-o491349728-p491349728-0-202203171042.jpg",
      heading: "HMT Kolam Rice 10 kg",
      price: "₹ 499.00",
      mrp: "M.R.p:",
      rupees: "₹ 630.00",
      save: "Save ₹ 131.00",
    },
    {
      "dis_section 2": 55,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/besan-1-kg/491349649",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/491349649/besan-1-kg-product-images-o491349649-p491349649-0-202203142037.jpg",
      heading: "Besan 1 kg",
      price: "₹ 75.00",
      mrp: "M.R.p:",
      rupees: "₹ 170.00",
      save: "Save ₹ 95.00",
    },
    {
      "dis_section 2": 21,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/tata-sampann-high-protein-unpolished-tur-arhar-dal-1-kg/490830932",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/490830932/tata-sampann-unpolished-tur-arhar-dal-1-kg-product-images-o490830932-p490830932-0-202207201859.jpg",
      heading: "Tata Sampann Unpolished Tur / Arhar Dal 1 kg",
      price: "₹ 149.00",
      mrp: "M.R.p:",
      rupees: "₹ 189.00",
      save: "Save ₹ 40.00",
    },
    {
      "dis_section 2": 17,
      "pro_detail href":
        "https://www.jiomart.com/p/groceries/aashirvaad-superior-mp-whole-wheat-atta-5-kg/590150648",
      imgsrc:
        "https://www.jiomart.com/images/product/150x150/490750661/aashirvaad-superior-mp-whole-wheat-atta-5-kg-product-images-o490750661-p590150648-0-202203170602.jpg",
      heading: "Aashirvaad Superior MP Whole Wheat Atta 5 kg",
      price: "₹ 232.00",
      mrp: "M.R.p:",
      rupees: "₹ 280.00",
      save: "Save ₹ 48.00",
    },
  ],
];
